/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { GridColumns } from '@mui/x-data-grid-pro';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import { AiOutlineWechat } from "react-icons/ai";

const InfoVOCFourSystemReport = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    return (
        <>
            <InnerHeadRoutes
                iconMUI={<AiOutlineWechat style={{ fontSize: '1.5em' }} />}
                labal_Head="รายงาน"
                label_nameRoute ="ข้อมูล VOC จาก 4 ระบบ"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                <Grid item xs={12}>

                </Grid>

                <Grid item xs={12}>
                </Grid>
            </Grid>
        </>
    )
}

export default InfoVOCFourSystemReport